"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Components = void 0;
var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteral"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _templateObject;
const Wrapper = _styledComponents["default"].div(_templateObject || (_templateObject = (0, _taggedTemplateLiteral2["default"])(["\n  .sun-editor {\n    border: 1px solid #CFCFCF;\n  }\n  .sun-editor .se-toolbar {\n    1px solid #CFCFCF\n  }\n  .sun-editor-editable table td *,\n  .sun-editor-editable table th *{\n    color: black !important;\n    background-color: white !important;\n  }\n"])));
const Components = exports.Components = {
  Wrapper
};